import PropTypes from 'prop-types';
import React from 'react';

import { HtmlContentLoader } from '@powdr/components';
import { useTrafficSignStatus } from '@powdr/hooks';

import { StyledTrafficSign, TrafficSignTitle } from './styles';

export const TrafficSign = ({
  trafficSignTitle,
  defaultCopy,
  trafficSign,
  colorProfile,
}) => {
  const trafficSignData = useTrafficSignStatus(trafficSign);

  if (!trafficSignData) return null;

  return (
    <StyledTrafficSign>
      <TrafficSignTitle $colorProfile={colorProfile}>{trafficSignTitle}</TrafficSignTitle>
      {(!trafficSignData?.messages) ? (
        <HtmlContentLoader html={defaultCopy?.value} />
      ) : (
        <HtmlContentLoader
          allowRerender
          html={trafficSignData?.messages.map((message) => `<p>${message.replaceAll('\n', '<br />')}</p>`).join()}
        />
      )}
    </StyledTrafficSign>
  );
};

TrafficSign.propTypes = {
  trafficSignTitle: PropTypes.string,
  defaultCopy: PropTypes.shape({
    value: PropTypes.string,
  }),
  trafficSign: PropTypes.string,
  colorProfile: PropTypes.string,
};
